import { render, staticRenderFns } from "./provideHeKangPeople.vue?vue&type=template&id=75f0c580&scoped=true&"
import script from "./provideHeKangPeople.vue?vue&type=script&lang=js&"
export * from "./provideHeKangPeople.vue?vue&type=script&lang=js&"
import style0 from "./provideHeKangPeople.vue?vue&type=style&index=0&id=75f0c580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f0c580",
  null
  
)

export default component.exports